import { Carousel, Divider, Image } from "antd";
import React from "react";
import { ItemInfoWrapper } from "../../container/Styles/Wrappers";
import { lng } from "../../library/language";

function StandardInfo({ product, store }) {
  return (
    <ItemInfoWrapper>
      <div className="carousel-container">
        <Carousel>
          {/* for creatives */}
          {product?.videos?.length > 0 && (
            <iframe
              // width="460"
              height="300"
              src={product.videos[0]}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style={{ zIndex: -100 }}
            ></iframe>
          )}
          {product.gen_files?.map((im, index) => (
            <Image alt={im.alt} src={im.url} key={index} />
          ))}
        </Carousel>
      </div>
      <div className="title" style={{ marginBottom: 10 }}>
        <h1 className="item-name">{product?.gen_name}</h1>
        {store?.name && <h2 className="item-parent">{lng(store?.name)}</h2>}
      </div>
      <div style={{ padding: 16 }}>
        <div className="ahp-description">{product?.gen_description["pt"]}</div>
        {product.gen_description_additional &&
          product.gen_description_additional["pt"] && (
            <>
              <Divider></Divider>
              <div className="ahp-description-additional">
                {product.gen_description_additional["pt"]}
              </div>
            </>
          )}
      </div>
    </ItemInfoWrapper>
  );
}

export default StandardInfo;
